import React, { useEffect, useState } from 'react';
import styles from './group-activity-page.module.css';
import HeaderBack from '../../components/HeaderBack/HeaderBack';
import { useParams } from 'react-router-dom';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import CounterList from '../../components/CounterList/CounterList';
import { getDocsArrayContainsOrderByBd } from '../../firebase';

export default function GroupActivityPage() {
  let { group_id } = useParams();
  const [loaderPage, setLoaderPage] = useState(false);
  const [restartUseEffect, setRestartUseEffect] = useState(0);
  const [webCounterList, setWebCounterList] = useState([]);

  // Потрібно коли обнуляєм активність перерендерити сторінку
  const restartPage = () => {
    setWebCounterList([]);
    setRestartUseEffect(new Date().getTime());
  };

  useEffect(() => {
    const getData = async () => {
      setLoaderPage(true);
      const docs = await getDocsArrayContainsOrderByBd(
        'loginWebCounter',
        'timeViewMilliseconds',
        'desc',
        group_id,
      );
      if (docs) {
        setWebCounterList(docs);
      }
      setLoaderPage(false);
    };
    getData();
  }, [restartUseEffect]);

  return (
    <>
      <HeaderBack />

      <div className={styles.page_wrapper}>{CounterList(webCounterList, restartPage)}</div>
      {loaderPage && <LoaderPage />}
    </>
  );
}
